export default function formatSegmentLabel(startTime, durationInMinutes) {
    const time = (startTime || "").substring(0, 5);
    const minutes = durationInMinutes || 0;
    const hours = Math.floor(minutes / 60);
    const remaining = minutes % 60;
    let duration = minutes + " min";
    if(hours > 0 && remaining > 0) {
        duration = hours + " uur " + remaining + " min";
    } else if(hours > 0) {
        duration = hours + " uur";
    }
    return time + " (" + duration + ")";
}
